import actions from '../../redux/actions';
import {connect} from 'react-redux';
import Stepper from '../../common/components/Stepper/Stepper';
import React, {useEffect, useState} from 'react';
import './CreateAttention.scss';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import ArrowBack from '../../common/components/ArrowBack/ArrowBack';
import FourthStep from './FourthStep';
import StatusCard from '../../common/components/StatusCard/StatusCard';
import Loader from '../../common/components/Loader/Loader';


const _CreateAttention = (props) => {
    const {
        cleanAttentionForCreate,
        createAttentionState,
        cleanCreateAttentionState,
        cleanAffiliate,
        cleanProvidersBranches,
        isSimulation,
        onExitSimulation,
    } = props;

    const [activeStep, setActiveStep] = useState(0);
    const [openStatusCard, setOpenStatusCard] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [attentionCreatedText, setAttentionCreatedText] = useState('');

    const onFinishStep = () => {
        setActiveStep(activeStep + 1);
    };

    const handleArrowBack = () => {
        setActiveStep(activeStep - 1);
    };

    const goToStep = (step) => {
        setActiveStep(step);
    };

    const simulationSteps = [
        {name: 'Nueva Consulta'},
        {name: 'Prestaciones'},
        {name: 'Cobertura'},
    ];

    const steps = {
        0: <FirstStep onFinish={onFinishStep} isSimulation={isSimulation}/>,
        1: <SecondStep onFinish={onFinishStep} isSimulation={isSimulation}/>,
        2: <ThirdStep onFinish={onFinishStep} isSimulation={isSimulation} onExitSimulation={onExitSimulation}/>,
        3: <FourthStep goToStep={goToStep} setAttentionInfoText={(value) => setAttentionCreatedText(value)}/>,
    };


    const resetAttentionCreation = () => {
        cleanAffiliate();
        cleanCreateAttentionState();
        cleanAttentionForCreate();
        cleanProvidersBranches();
        setOpenStatusCard(false);
        goToStep(0);
    };

    useEffect(() => {
        if (createAttentionState.loading) {
            setIsLoading(true);
        }
        if (createAttentionState.success) {
            setIsLoading(false);
            setOpenStatusCard(true);
        }
    }, [createAttentionState]);

    if (loading) {
        return (
            <div className={'v2-create-attention-container'}>
                <Loader/>;
            </div>
        );
    }

    return (
        <div className={'v2-create-attention-container'}>
            {openStatusCard ?
                <div className={'v2-status-card-container'}>
                    <StatusCard title={'Atención creada'} status={'success'} buttonText={'Ir al inicio'}
                                text={attentionCreatedText}
                                buttonOnClick={() => resetAttentionCreation()}/>
                </div> :
                <>
                    <div className={'v2-create-attention-stepper-container'}>
                        <div className={'v2-create-attention-arrow-container'}>
                            {activeStep > 0 && <ArrowBack onClick={handleArrowBack}/>}
                        </div>
                        <Stepper activeIndex={activeStep} steps={isSimulation && simulationSteps}/>
                    </div>
                    {steps[activeStep]}
                </>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    createAttentionState: state.home.createAttentionState,
});

const mapDispatchToProps = (dispatch) => ({
    cleanAttentionForCreate: () => dispatch(actions.home.cleanAttentionForCreate()),
    cleanCreateAttentionState: () => dispatch(actions.home.cleanCreateAttentionState()),
    cleanAffiliate: () => dispatch(actions.home.cleanAffiliates()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
});


export default connect(mapStateToProps, mapDispatchToProps)(_CreateAttention);
